export default "__VITE_ASSET__DlPUKawM__"